const platformGuarantees = [
  "Dedicated Infrastructure",
  "Dedicated Databases",
  "Tenant-Specific Domains",
  "Secure & Isolated by Design",
];


export const fallbackTiers = [
  {
    id: 1,
    tier: 1,
    name: "Telivi Tier 1",
    label: "Starter",
    marketingDescription: "For businesses establishing their digital operations.",
    description: "Starter tier subscription",
    monthlyPrice: null,
    setupFee: 500,
    currency: "USD",
    turnaroundDays: 5,
    recommended: false,
    servicesIncluded: [
      "Core Service (select one)",
      "Blog & Article Publishing as a Service",
    ],
    dashboardsIncluded: [
      "Core Service Dashboard",
      "Blog & Article Dashboard",
    ],
    platformGuarantees,
    limits: [
      "Up to 10 users",
      "Standard performance",
      "Email support",
    ],
    entitlements: {
      PROPERTY_ENABLED: true,
      BLOG_ENABLED: true,
      HELPDESK_ENABLED: false,
      PAYMENTS_ENABLED: false,
    },
  },
  {
    id: 2,
    tier: 2,
    name: "Telivi Tier 2",
    label: "Professional",
    marketingDescription: "For teams managing customer requests and internal operations.",
    description: "Professional tier subscription",
    monthlyPrice: null,
    setupFee: 1000,
    currency: "USD",
    turnaroundDays: 12,
    recommended: true,
    servicesIncluded: [
      "Core Service (select one)",
      "Blog & Article Publishing as a Service",
      "Helpdesk as a Service",
      "Ticketing & email ingestion",
      "Attachments & agent roles",
      "SLA tracking",
    ],
    dashboardsIncluded: [
      "Core Service Dashboard",
      "Helpdesk Dashboard",
      "Blog & Article Dashboard",
    ],
    platformGuarantees,
    limits: [
      "Up to 50 users",
      "Higher usage limits",
      "SLA-backed uptime",
    ],
    entitlements: {
      PROPERTY_ENABLED: true,
      BLOG_ENABLED: true,
      HELPDESK_ENABLED: true,
      PAYMENTS_ENABLED: false,
    },
  },
  {
    id: 3,
    tier: 3,
    name: "Telivi Tier 3",
    label: "Business",
    marketingDescription: "For businesses ready to manage billing and revenue.",
    description: "Business tier subscription",
    monthlyPrice: null,
    setupFee: 1500,
    currency: "USD",
    turnaroundDays: 18,
    recommended: false,
    servicesIncluded: [
      "Core Service (select one)",
      "Blog & Article Publishing as a Service",
      "Helpdesk as a Service",
      "Payments as a Service",
      "Invoices & subscriptions",
      "Stripe Checkout integration",
      "Webhooks & revenue dashboard",
    ],
    dashboardsIncluded: [
      "Core Service Dashboard",
      "Helpdesk Dashboard",
      "Blog & Article Dashboard",
      "Payments Dashboard",
    ],
    platformGuarantees,
    limits: [
      "Up to 100 users",
      "All core Telivi services enabled",
    ],
    entitlements: {
      PROPERTY_ENABLED: true,
      BLOG_ENABLED: true,
      HELPDESK_ENABLED: true,
      PAYMENTS_ENABLED: true,
    },
  },
];

export const entitlementLabels = {
  PROPERTY_ENABLED: "Property",
  BLOG_ENABLED: "Blog or Article",
  HELPDESK_ENABLED: "Helpdesk",
  PAYMENTS_ENABLED: "Payments",
};
